var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.filterListBulk
    ? _c(
        "div",
        { staticClass: "mobile-filter-wrapper w-100" },
        [
          _vm._l(_vm.facets.slice(0, _vm.initialVisibleCount), function(facet) {
            return _c("item-filter", {
              key: "mobile_always_" + facet.id,
              attrs: {
                facet: facet,
                "padding-classes": _vm.paddingClasses,
                "padding-inline-styles": _vm.paddingInlineStyles,
                "filter-list-bulk": _vm.filterListBulk,
                "active-facet-id": _vm.activeFacetId,
                "show-badges": _vm.showBadges
              },
              on: {
                "toggle-accordion": function($event) {
                  _vm.activeFacetId = $event
                }
              }
            })
          }),
          _vm._v(" "),
          _c("transition", { attrs: { name: "fade" } }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showMobileMore,
                    expression: "showMobileMore"
                  }
                ],
                staticClass: "mobile-filter-wrapper mt-0"
              },
              _vm._l(_vm.facets.slice(_vm.initialVisibleCount), function(
                facet
              ) {
                return _c("item-filter", {
                  key: "mobile_collapsed_" + facet.id,
                  attrs: {
                    facet: facet,
                    "padding-classes": _vm.paddingClasses,
                    "padding-inline-styles": _vm.paddingInlineStyles,
                    "filter-list-bulk": _vm.filterListBulk,
                    "active-facet-id": _vm.activeFacetId
                  },
                  on: {
                    "toggle-accordion": function($event) {
                      _vm.activeFacetId = $event
                    }
                  }
                })
              }),
              1
            )
          ]),
          _vm._v(" "),
          _vm.facets.length > _vm.initialVisibleCount
            ? _c(
                "button",
                {
                  staticClass:
                    "btn more-filter btn-medium-large position-relative d-flex align-items-center justify-content-center",
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      _vm.showMobileMore = !_vm.showMobileMore
                    }
                  }
                },
                [
                  _c("span", { staticStyle: { "padding-top": "2px" } }, [
                    _vm._v(_vm._s(_vm.toggleButtonTextMobile))
                  ]),
                  _vm._v(" "),
                  _c(
                    "svg",
                    {
                      class: [
                        "position-absolute arrDown",
                        { rotate180: _vm.showMobileMore }
                      ],
                      staticStyle: { right: ".5rem" },
                      attrs: {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "13.182",
                        height: "8",
                        viewBox: "0 0 13.182 8"
                      }
                    },
                    [
                      _c("path", {
                        attrs: {
                          id: "chevron-down-solid",
                          d:
                            "M11.735,131.282l-5.867-5.867a.724.724,0,0,1,0-1.025l.684-.684a.724.724,0,0,1,1.023,0l4.671,4.649,4.671-4.649a.724.724,0,0,1,1.023,0l.684.684a.724.724,0,0,1,0,1.025l-5.867,5.867A.725.725,0,0,1,11.735,131.282Z",
                          transform: "translate(-5.656 -123.494)",
                          fill: "#464646"
                        }
                      })
                    ]
                  )
                ]
              )
            : _vm._e()
        ],
        2
      )
    : _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.facets && _vm.facets.length > 0,
              expression: "facets && facets.length > 0"
            }
          ],
          staticClass: "filter-wrapper"
        },
        [
          _c(
            "div",
            {
              staticClass: "filter-list d-grid",
              staticStyle: { "margin-bottom": "10px" }
            },
            _vm._l(_vm.facets.slice(0, _vm.initialVisibleCount), function(
              facet
            ) {
              return _c("item-filter", {
                key: "always_" + facet.id,
                attrs: { facet: facet, "show-badges": _vm.showBadges }
              })
            }),
            1
          ),
          _vm._v(" "),
          _vm.facets.length > _vm.initialVisibleCount
            ? _c(
                "button",
                {
                  staticClass:
                    "btn more-filter btn-medium-large position-relative d-flex align-items-center justify-content-center",
                  staticStyle: { "margin-bottom": "10px" },
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      _vm.showMore = !_vm.showMore
                    }
                  }
                },
                [
                  _c("span", { staticStyle: { "padding-top": "2px" } }, [
                    _vm._v(_vm._s(_vm.toggleButtonText))
                  ]),
                  _vm._v(" "),
                  _c(
                    "svg",
                    {
                      class: [
                        "position-absolute arrDown",
                        { rotate180: _vm.showMore }
                      ],
                      staticStyle: { right: ".5rem" },
                      attrs: {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "13.182",
                        height: "8",
                        viewBox: "0 0 13.182 8"
                      }
                    },
                    [
                      _c("path", {
                        attrs: {
                          id: "chevron-down-solid",
                          d:
                            "M11.735,131.282l-5.867-5.867a.724.724,0,0,1,0-1.025l.684-.684a.724.724,0,0,1,1.023,0l4.671,4.649,4.671-4.649a.724.724,0,0,1,1.023,0l.684.684a.724.724,0,0,1,0,1.025l-5.867,5.867A.725.725,0,0,1,11.735,131.282Z",
                          transform: "translate(-5.656 -123.494)",
                          fill: "#464646"
                        }
                      })
                    ]
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("transition", { attrs: { name: "fade" } }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showMore,
                    expression: "showMore"
                  }
                ],
                staticClass: "filter-collapse",
                attrs: { id: "filter-collapse_" + _vm._cid }
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "component-loading",
                    class: { "is-loading": _vm.isLoading }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "filter-list d-grid" },
                      _vm._l(
                        _vm.facets.slice(_vm.initialVisibleCount),
                        function(facet) {
                          return _c("item-filter", {
                            key: "collapsed_" + facet.id,
                            attrs: {
                              facet: facet,
                              "show-badges": _vm.showBadges
                            }
                          })
                        }
                      ),
                      1
                    )
                  ]
                )
              ]
            )
          ])
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }